export default function() {
  const apiHost = process.env.APIHOST || window.location.host;
  const protocol = !apiHost.startsWith('http') ? window.location.protocol + "//" : ''; // Add protocol if none is served already
  const host = protocol + apiHost.replace(":8080", ":80"); // Port replace = Fix for localhost mainly - API runs under port 80
  return host + '/api';
}
